import { LibraryPageContext } from "@/pages/library_v2/components/filesView/context";
import {
  FILE_STATUS_PARAMS,
  FileStatus,
} from "@/pages/library_v2/components/filesView/types";
import { useTrans } from "@/translations";

import { useCallback, useContext, useMemo } from "react";

export const FileListBreadcrumbs: React.FC = () => {
  const { t } = useTrans();
  const {
    displayedFiles,
    selectedViewId,
    setSelectedViewId,
    selectedFolderName,
    setSelectedFolderName,
    searchValue,
  } = useContext(LibraryPageContext);

  const navigateToPublished = useCallback(() => {
    setSelectedViewId(FileStatus.PUBLISHED);
    setSelectedFolderName("");
  }, [setSelectedFolderName, setSelectedViewId]);

  const crumbLabel = useMemo(() => {
    if (searchValue) {
      return t("libraryPage:searchValueHeader");
    }

    if (selectedFolderName) {
      return selectedFolderName;
    }

    if (selectedViewId) {
      return t(FILE_STATUS_PARAMS[selectedViewId].folderNameKey);
    }

    return "";
  }, [selectedFolderName, t, selectedViewId, searchValue]);

  return (
    <div className="flex flex-wrap items-baseline gap-[10px] px-5 pt-[15px] pb-[14px]">
      {!!selectedFolderName && (
        <>
          <button
            type="button"
            onClick={navigateToPublished}
            className="cursor-pointer text-[13px] text-[#6F6C6C] underline"
          >
            {t(FILE_STATUS_PARAMS[FileStatus.PUBLISHED].folderNameKey)}
          </button>
          <span className="text-[13px] text-[#c4bcbc]">/</span>
        </>
      )}
      <span className="text-[14px] font-semibold text-[#1D1C1C]">
        {crumbLabel}
      </span>
      <span className="text-[12.5px] text-[#9a958f]">
        {displayedFiles.length}{" "}
        {t(searchValue ? "libraryPage:nrSearchMatches" : "libraryPage:nrFiles")}
      </span>
    </div>
  );
};
